import _ from 'lodash';
import React from 'react';
const TemplateCardListItems = _ref => {
  let {
    templates,
    isMobileView,
    SSRFlow,
    CardComponent,
    LoadingState,
    showFeatures,
    showSecondaryBtn
  } = _ref;
  const haveTemplates = _.size(templates) > 0;
  if (haveTemplates) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, _.map(templates, (template, index) => /*#__PURE__*/React.createElement("li", {
      key: template.id
    }, /*#__PURE__*/React.createElement(CardComponent, {
      isMobileView: isMobileView,
      template: template,
      forceRender: SSRFlow,
      index: index,
      showFeatures: showFeatures,
      showSecondaryBtn: showSecondaryBtn
    }))));
  }
  return /*#__PURE__*/React.createElement(LoadingState, {
    isMobileView: isMobileView
  });
};
export default TemplateCardListItems;
//# sourceMappingURL=TemplateCardListItems.js.map